import { render } from "./ModokashiMarketsScreen.vue?vue&type=template&id=5afe3646&scoped=true&ts=true&lang=pug"
import script from "./ModokashiMarketsScreen.vue?vue&type=script&lang=ts"
export * from "./ModokashiMarketsScreen.vue?vue&type=script&lang=ts"

import "./ModokashiMarketsScreen.vue?vue&type=style&index=0&id=5afe3646&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afe3646"]])

export default __exports__